/**
 * ^: Asserts the start of the string.
 * \S*: Matches any non-whitespace character (except newline) zero or more times.
 * $: Asserts the end of the string.
 */
export const regexWhiteSpace = /^\S*$/;

/**
 * ^: Asserts the start of the string.
 * [a-zA-Z0-9]*: Matches any combination of uppercase letters, lowercase letters, and digits, zero or more times.
 */
export const regexSpecialChars = /^[a-zA-Z0-9]*$/;

/**
 * ^: Asserts the start of the string.
 * [a-zA-Z0-9_]*: Matches any combination of uppercase letters, lowercase letters, and digits, underscore, zero or more times.
 */
export const regexSpecialCharsContains_ = /^[a-zA-Z0-9_]*$/;

/**
 * ^: Asserts the start of the string.
 * [A-Za-z0-9\s]+: Matches any combination of uppercase letters, lowercase letters, and digits, space, zero or more times.
 */
export const regexSpecialCharsContainsSpaceBar = /^[A-Za-z0-9\s]+$/;

/**
 * ^: Asserts the start of the string.
 * [a-zA-Z0-9_.]*: Matches any combination of uppercase letters, lowercase letters, and digits, dot, underscore, zero or more times.
 */
export const regexSpecialCharsContains_BarAndDot = /^[a-zA-Z0-9_.]*$/;

/**
 * ^: Asserts the start of the string.
 * [a-zA-Z0-9_@-]*: Matches any combination of uppercase letters, lowercase letters, and digits, underscore, dash, at sign, zero or more times.
 */
export const regexCode = /^[a-zA-Z0-9_@-]*$/;

/**
 * regex CCCD/CMND
 * chỉ cho nhập số /^\d{8,16}$/
 */
export const regexIdentityCardNumber = /^[A-Za-z0-9]{8,16}$/;
/**
 * ^: Bắt đầu của chuỗi.
 * \d{10}: Độ dài là 10 ký tự số.
 * (\d{4})?: Phần này là tùy chọn, nếu có, thì là thêm 4 ký tự số nữa.
 * $: Kết thúc chuỗi.
 */
export const regexTaxCodeHas10or14Char = /^\d{10}(\d{4})?$/;
/**
 * ^: Asserts the start of the string.
 * [0-9]{10}: Matches exactly 10 digits.
 * |: Matches either the previous pattern or the next pattern.
 * ^(?=.*?[0-9])(?=.*?[-]).{14}$: Matches a string that is either exactly 10 digits or 14 characters where:
 *
 */
export const regexTaxCodeHas10OrCharIncludeDash =
    /^[0-9]{10}$|^(?=.*?[0-9])(?=.*?[-]).{14}$/;
/**
 *
 * @param pass
 * ^ asserts the start of the string.
 * (?=.*[a-z]) is a positive lookahead to ensure the presence of at least one lowercase letter.
 * (?=.*[A-Z]) is a positive lookahead to ensure the presence of at least one uppercase letter.
 * (?=.*\d.*\d) is a positive lookahead to ensure the presence of at least two numbers.
 * [a-zA-Z\d]{8,} matches a combination of uppercase letters, lowercase letters, and numbers with a minimum length of 8 characters.
 * $ asserts the end of the string.
 */
export const regex1Upper1Lower2Number8LengthMin =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*\d)[a-zA-Z\d]{8,}$/;

/**
 * Explanation of the regex pattern:
 * ^: Start of the string.
 * (?=.*[a-z]): Positive lookahead assertion to check for at least one lowercase letter.
 * (?=.*[A-Z]): Positive lookahead assertion to check for at least one uppercase letter.
 * (?=.*\d.*\d): Positive lookahead assertion to check for at least two digits.
 * (?=.*[^a-zA-Z\d]): Positive lookahead assertion to check for at least one special character (non-alphanumeric).
 * .{8,}: Match any character (except newline) at least 8 times.
 * $: End of the string.
 */
export const regex1Upper1Lower1Special2Number8LengthMin =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;

/**
      ^: Asserts the start of the string.
      \/: Matches the forward slash ("/") character at the beginning of the pathname.
      [\w\/.-]*: Matches any combination of word characters (letters, digits, and underscores), forward slashes, dots, and dashes, similar to the previous regex.
      (?:\?.*)?: Non-capturing group that matches an optional query parameter. ?: indicates a non-capturing group, \? matches the question mark, and .* matches any characters after the question mark.
      $: Asserts the end of the string.
       */
export const regexPathName = /^\/[\w\/.-]*(?:\?.*)?$/;

/**
      \b: Asserts a word boundary to ensure that we match whole URLs.
      (?:...|...): Groups two alternative patterns together.
      (?:https?|ftp): Matches either "http" or "https" or "ftp".
      :\/\/: Matches the "://" after the protocol (e.g., "http://").
      (?:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|localhost:\d+): Groups two alternatives:
      [a-zA-Z0-9.-]+\.[a-zA-Z]{2,}: Matches a standard domain name (e.g., "example.com").
      localhost:\d+: Matches "localhost" followed by a colon and one or more digits for the port number.
      \S*: Matches zero or more non-whitespace characters, which allows for the inclusion of path and query parameters.

      * With this merged regex, you will be able to match both standard URLs like http://example.com and URLs with the format http://localhost:3000
 */
export const regexUrl =
    /\b(?:(?:https?|ftp):\/\/)?(?:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|localhost:\d+)\S*/;

/** ^: Matches the start of the string.
(https?|ftp): Matches "http", "https", or "ftp".
:\/\/: Matches the "://" part of the URL.
[^\s/$.?#]: Matches any character that is not a whitespace character, "/", "?", ".", or "#".
.*: Matches zero or more of any characters.
$: Matches the end of the string. */
export const regexPathNameOrUrl =
    /^(\/[a-zA-Z0-9_-]+)*(\.html)?$|(https?:\/\/[^\s/$.?#].[^\s]*)$/;
/**
       * ^: Start of the string.
      [a-zA-Z0-9._%+-]+: Matches one or more of the allowed characters for the username part of the email address.
      @: Matches the "@" symbol.
      [a-zA-Z0-9.-]+: Matches one or more of the allowed characters for the domain name part of the email address.
      \.: Matches a literal dot (.) character (needs to be escaped with a backslash).
      [a-zA-Z]{2,}: Matches at least two alphabetical characters for the top-level domain (TLD) part of the email address.
      $: End of the string.
       */
export const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
/**
 * why use this instead of Number.isInterger ? because Number.isInterger('123.') is still a number
 * ^: Asserts the start of the string.
      -?: Matches an optional minus sign for negative integers.
      \d+: Matches one or more digits.
      $: Asserts the end of the string.
 */
export const regexInteger = /^-?\d+$/;

/**^: Matches the start of the string.
(?!.*,,): A negative lookahead assertion to ensure there are no consecutive commas.
(?:[a-zA-Z0-9]{3,5},)*: This part allows for a comma-separated list of substrings with lengths between 3 and 5 characters.
(?:...): A non-capturing group for the substring and comma.
[a-zA-Z0-9]{3,5}: Matches 3 to 5 alphanumeric characters.
,: Matches a comma to separate the substrings.
[a-zA-Z0-9]{3,5}: Matches the final substring, which must have a length between 3 and 5 characters.
$: Matches the end of the string.*/
export const regexSpecial_Hdl_Code =
    /^(?!.*,,)(?:[a-zA-Z0-9]{3,5},)*[a-zA-Z0-9]{3,5}$/;

/**This pattern matches either a single digit between 1 and 7 or no digit at all (i.e., an empty string or just a 0). The ? quantifier means "zero or one occurrence."
 */
export const regex1DigitIn1to7 = /^[1-7]$/;

/**This pattern ensures that the input starts with a digit from 1 to 9 and can have an optional second digit but won't match if the input is "0" or if it's longer than 2 characters. */
export const regex2DigitIn1to9 = /^[1-9][0-9]?$/;

/**
 * ^: Asserts the start of the string.
 * \+?: Matches an optional plus sign (+) at the beginning.
 * [0-9]: Matches a digit between 0 and 9.
 * \d{4,16}: Matches 4 to 16 digits.
 * $: Asserts the end of the string.
 */
export const regexPhoneNumber = /^\+?[0-9]\d{4,16}$/;

/**
 * ^: Asserts the start of the string.
 * [a-zA-Z0-9._@-]*: Matches any combination of uppercase letters, lowercase letters, and digits, dot, underscore, dash, at sign, zero or more times.
 */
export const regexUserName = /^[a-zA-Z0-9._@-]*$/;

/**
 * ^: Asserts the start of the string.
 * (?=.*?[A-Z]): Positive lookahead to ensure at least one uppercase letter.
 * (?=.*?[a-z]): Positive lookahead to ensure at least one lowercase letter.
 * (?=.*?[0-9]): Positive lookahead to ensure at least one digit.
 * (?=.*?[#?!@$%^&_*-]): Positive lookahead to ensure at least one special character.
 * .{8,}: Matches any character (except newline) at least 8 times.
 * $: Asserts the end of the string.
 */
export const regexPassword =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&_*-]).{8,}$/;

/**
 * ^: Asserts the start of the string.
 * (https?:\/\/[^\s/$.?#].[^\s]*): Matches a URL starting with "http" or "https" followed by any characters that are not whitespace, "/", "$", ".", "?", "#", or newline.
 * |: Matches either the previous pattern or the next pattern.
 * ^\/[^\s]*$: Matches a URL starting with a forward slash ("/") followed by any characters that are not whitespace.
 */
export const regexLink = /^(https?:\/\/[^\s/$.?#].[^\s]*)|(^\/[^\s]*)$/;

/**
 * ^: Asserts the start of the string.
 */
export const regexUUID = /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/;
